import { deleteWorkspaceItem } from '@pn/core/operations/workspace/crud/deleteWorkspaceItem';
import { useWorkspaceStorage } from '@pn/core/storage';
import React from 'react';
import { useIntelWorkspaceItemsStorage } from 'src/application/storage';

export function useAutoDeleteWorkspaceItems() {
  const { intelWorkspaceItems } = useIntelWorkspaceItemsStorage();
  const { allWorkspaceItems } = useWorkspaceStorage();

  const prevIntelIdsRef = React.useRef<string[]>([]);

  React.useEffect(() => {
    const currentIds = intelWorkspaceItems.map((item) => item.id);
    const removedIds = prevIntelIdsRef.current.filter(
      (id) => !currentIds.includes(id)
    );

    removedIds.forEach((id) => {
      const workspaceItem = allWorkspaceItems[id];
      if (workspaceItem) deleteWorkspaceItem(workspaceItem);
    });

    prevIntelIdsRef.current = currentIds;
  }, [intelWorkspaceItems, allWorkspaceItems]);
}
